import Notifications from './Notifications';

export default Notifications;



// WEBPACK FOOTER //
// ./src/components/Notifications/index.js